import { Injectable, OnDestroy } from '@angular/core';
import { deepCopy } from '@common/helpers';
import { INITIAL_MYBOOKING_STATE, MyBooking } from '@common/interfaces/mybooking/mybooking.interface';
import { selectMyBookingState, updateMyBooking } from '@common/store/my-booking';
import { select, Store } from '@ngrx/store';
import { map, Observable, Subscription } from 'rxjs';

@Injectable()
export class MyBookingStoreService implements OnDestroy {
  private _subscription = new Subscription();
  private _myBooking$: Observable<MyBooking>;
  private storeCurrentValue = INITIAL_MYBOOKING_STATE;

  constructor(private readonly store: Store) {
    this._myBooking$ = this.store.pipe(
      select(selectMyBookingState),
      map((state) => state.model ?? INITIAL_MYBOOKING_STATE)
    );
    this._subscription.add(
      this._myBooking$.subscribe((data) => {
        this.storeCurrentValue = data;
      })
    );
  }

  updateMyBooking(value: MyBooking) {
    this.store.dispatch(updateMyBooking({ model: { ...deepCopy(this.storeCurrentValue), ...value } }));
  }

  public getMyBookingModel$(): Observable<MyBooking> {
    return this._myBooking$;
  }

  get myBooking() {
    return this.storeCurrentValue;
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
